module.exports = __webpack_public_path__ + "img/site-logo.20cdc6dd.jpg";